import React, { useState, useEffect } from 'react';
import styles from './section.module.css';
import { Link } from 'react-router-dom';
import { cardGif, cardGif1, cardGif2, cardGif3, cardGif4, cardGif5, cardGif6, cardGif7, serviceArrow } from '../../../assets';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from "react-redux";
import { fetchWhatWeDoData } from '../../slice/whatWeDoSlice';
import { IMAGE_URL } from "../../helpers/api_helper";
import { useTranslation } from 'react-i18next';
import '../../../i18n';
import { LANG_EN } from '../../helpers/constant.jsx';

const SectionSecond = () => {
    const gifs = [
        cardGif,
        cardGif5,
        cardGif2,
        cardGif1,
        cardGif3,
        cardGif4,
        cardGif6,
        cardGif7,
    ];

    const services = [
        { name: 'Communication', color: '#3e5beb', path: '/what-we-do' },
        { name: 'Digital', color: '#6652C4', path: '/what-we-do' },
        { name: 'Social', color: '#CE1974', path: '/what-we-do?' },
        { name: 'Branding', color: '#6652C4', path: '/what-we-do' },
        { name: 'Production', color: '#DD043E', path: '/what-we-do' },
        { name: 'Influencer', color: '#3e5beb', path: '/what-we-do' },
        { name: 'Podcast', color: '#CE1974', path: '/what-we-do' },
        { name: 'Events', color: '#DD043E', path: '/what-we-do' }
    ];

    const [colors, setColors] = useState([]);
    const colorPalette = ['#000000', '#DD043E', '#3e5beb', '#CE1974', '#6652C4'];

    const [hoveredIndex, setHoveredIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);



    const dispatch = useDispatch();
    const { data: serviceData, loading, error } = useSelector((state) => state.whatWeDo);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        dispatch(fetchWhatWeDoData());
    }, [dispatch]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // Check on initial load

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Log the data whenever it changes
    useEffect(() => {
        if (serviceData.length > 0) {
            console.log("service Data from Redux:", serviceData);
            const generatedColors = serviceData.map((_, index) => colorPalette[index % colorPalette.length]);
            setColors(generatedColors);
        }
    }, [serviceData]);


    const handleMouseEnter = (index) => {
        if (!isMobile) {
            setHoveredIndex(index);
        }
    };

    const handleMouseLeave = () => {
        if (!isMobile) {
            setHoveredIndex(0);
        }
    };

    const handleLinkClick = (e, path, name) => {
        localStorage.setItem('redirect', name);
        if (isMobile) {
            e.stopPropagation(); // Prevent section toggle on mobile link click
        } else {
            // Redirect for desktop on the whole section
            window.location.href = path;
        }
    };

    const handleTitleClick = (index) => {
        if (isMobile) {
            setHoveredIndex((prevIndex) => (prevIndex === index ? 0 : index));
        }
    };
    const { ref: titleRef, inView: titleInView, textAnimation } = useTextAnimation();

    return (
        <div className={styles.OurserviceSec_inner}>
            <div className={styles.OurserviceSec_title}>
                <Link to="/what-we-do">
                    <motion.h3 ref={titleRef}
                        initial="hidden"
                        animate={titleInView ? "visible" : "hidden"}
                        custom={0}
                        variants={textAnimation}
                    >{t('homeWhat')} <span>{t('homeWeDo')}</span></motion.h3>
                </Link>
            </div>
            {/*  <div className={styles.OurserviceSec_slider}>
                {serviceData.map((service, i) => (
                    <div
                        className={`${styles.OurserviceSec_links} ${(hoveredIndex === i) ? styles.active : ''}`}
                        key={service._id}
                        onMouseEnter={() => handleMouseEnter(i)}
                        onMouseLeave={handleMouseLeave}
                        onClick={(e) => handleLinkClick(e, '/what-we-do', service.title)}
                        style={{ '--bg-color': colors[i] }}
                    >
                        <Link
                            to={'/what-we-do'}
                            className={styles.OurserviceSec_link}
                            onClick={(e) => handleLinkClick(e, service.path, service.title)} // Redirect only link (mobile)
                        >
                            <img src={serviceArrow} alt="" />
                        </Link>
                        <div
                            className={styles.OurserviceSec_lTitle}
                            onClick={() => handleTitleClick(i)} // Expand section on title click (mobile)
                        >
                            <h3>{service.title}</h3>
                        </div>
                        <div className={styles.OurserviceSec_slideEnd}>
                            <img src={`${IMAGE_URL}/whatWeDo/${service.image}`} alt={`${service.title} gif`} />
                        </div>
                    </div>
                ))}
            </div> */}


            <div className={styles.OurserviceSec_slider}>
                {Array.isArray(serviceData) && serviceData.length > 0 ? (
                    serviceData.map((service, i) => (
                        <div
                            className={`${styles.OurserviceSec_links} ${(hoveredIndex === i) ? styles.active : ''}`}
                            key={service._id}
                            onMouseEnter={() => handleMouseEnter(i)}
                            onMouseLeave={handleMouseLeave}
                            onClick={(e) => handleLinkClick(e, '/what-we-do', service.title)}
                            style={{ '--bg-color': colors[i] }}
                        >
                            <Link to={'/what-we-do'} className={styles.OurserviceSec_link}
                                onClick={(e) => handleLinkClick(e, service.path, service.title)}>
                                <img src={serviceArrow} alt="" />
                            </Link>
                            <div className={styles.OurserviceSec_lTitle} onClick={() => handleTitleClick(i)}>
                                {/*  <h3>{service.title}</h3> */}
                                <h3>{i18n.language === LANG_EN ? service.title : service.titleAr}</h3>
                            </div>
                            <div className={styles.OurserviceSec_slideEnd}>
                                <img src={`${IMAGE_URL}/whatWeDo/${service.image}`} alt={`${service.title} gif`} loading='lazy' />
                            </div>
                        </div>
                    ))
                ) : (
                    <p>Loading services...</p> // Fallback UI
                )}
            </div>

        </div>
    );
};

export default SectionSecond;
